export const env = { configuration: 'dev', platform: 'web' };